export default function CommunityPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100">
      <h1 className="text-4xl font-bold mb-4">Community</h1>
      <p className="text-lg text-gray-700 mb-8">Join our community to connect, share, and learn with other creators.</p>
    </div>
  )
}
